import { usersApiClient } from '@owl-frontend/api-client';
import { asyncActionStateMatchers, invoke } from '@owl-frontend/redux';
import usersSlice from './interface';

const slice = usersSlice
  .addAsyncSagas({
    createUser: invoke(usersApiClient.users.create),
    listUsers: invoke(usersApiClient.users.list),
    deleteUser: invoke(usersApiClient.users.delete),
    updateUserRole: invoke(usersApiClient.users.updateUserRole),
    updateUserSettings: invoke(usersApiClient.users.updateUserSettings),
    updateEmailSubscriptions: invoke(
      usersApiClient.users.updateEmailSubscriptions
    ),
  })
  .addReducers({
    'listUsers/fulfilled': (state, action) => {
      state.users = action.payload;
    },
  });
export const actions = slice.actions;
export default slice.addExtra(
  asyncActionStateMatchers(actions)
    .all()
    .config({ createUser: { storeRequestArg: true } })
);
